import { message } from 'antd';
import { config } from 'util/config';
import { httpClient } from "util/Api";
import * as globalFunction from 'util/GlobalFunction';

export function addBySection({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  sectionComponent.child.map((child, i) => {
    if (child.current != null && child.current?.child.current?.props.sectionName === 'CompanyTeam') {
      child.current?.setState({ showModal: true, componentType: 'Create' });

      //必须如下顺序设置, 否则再次弹出时无法清空已选项
      setTimeout(() => {
        child.current?.customForm.current?.additionalFormRef.current?.child.current?.setState({ selectedRowKeys: [], companyTeamMemberList: [] });
        child.current?.customForm.current?.additionalFormRef.current?.child.current?.getCompanyUserData();
      }, config.setTimeoutMilliSecond * 10);
    }
  })
}

export function editBySection({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  sectionComponent.setState({ showModal: true, componentType: 'Edit' });
  setTimeout(() => {
    httpClient
      .get(pageComponent.props.areaName + '/' + sectionName + '/' + parameter.key)
      .then(({ data }) => {
        if (data.result) {
          sectionComponent.customForm.current?.setState({ currentDataKey: data.data.key });

          //把处理后的数据赋值给表单
          sectionComponent.customForm.current?.formRef.current?.setFieldsValue(data.data);
          sectionComponent.customForm.current?.setState({ formData: data.data });

          //获取编辑时的原 companyTeamMember 列表, 设置受控选中项 selectedRowKeys
          let selectedRowKeys = [];
          let companyTeamMemberList = [];
          data.data.CompanyTeamMemberList.map((companyTeamMember, i) => {
            selectedRowKeys.push(companyTeamMember.CompanyUserId);
            companyTeamMemberList.push(companyTeamMember);
          })

          setTimeout(() => {
            sectionComponent.customForm.current?.additionalFormRef.current?.child.current?.setState({ selectedRowKeys, companyTeamMemberList });
            //先设置完默认选中项, 再获取实际 CompanyUser 列表, 否则会设置不上
            sectionComponent.customForm.current?.additionalFormRef.current?.child.current?.getCompanyUserData();
          }, config.setTimeoutMilliSecond * 10);
        } else {
          globalFunction.handleResultError(data, pageComponent);
        }
      })
      .catch(function (error) {
        globalFunction.handleError(error, pageComponent);
      });
  }, config.setTimeoutMilliSecond);
}

// CompanyTeam 专用 cancelCustomForm：覆盖 Common.cancelCustomForm。
// 取消关闭弹窗前先清空成员多选(selectedRowKeys / companyTeamMemberList)；
// 否则弹窗实例被复用, 下次打开会先显示上一次的勾选, 等数据回来才刷新, 造成页面闪一下。
export function cancelCustomForm({ sectionComponent } = {}) {
  sectionComponent.setState({ showModal: false, customFormSubmitting: false, isFormModified: false, componentType: null });
  setTimeout(() => {
    sectionComponent.customForm.current?.resetFields();
    sectionComponent.customForm.current?.additionalFormRef.current?.child.current?.setState({ selectedRowKeys: [], companyTeamMemberList: [] });
  }, config.setTimeoutMilliSecond);
}

export function showSelectedItemsOnlyOnChange({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  let data = sectionComponent.customForm.current?.additionalFormRef.current?.child.current?.state.data;
  if (parameter) {
    let companyTeamMemberList = sectionComponent.customForm.current?.additionalFormRef.current?.child.current?.state.companyTeamMemberList;
    data = data.map((group, i) => {
      group.DataList.map((data, j) => {
        if (companyTeamMemberList.map(obj => { return obj.CompanyUserId; }).indexOf(data.CompanyUserId) >= 0) {
          data.hide = false;
        } else {
          data.hide = true;
        }
        return data;
      })
      return group;
    })
  } else {
    data = data.map((group, i) => {
      group.DataList.map((data, j) => {
        data.hide = false;
        return data;
      })
      return group;
    })
  }
  sectionComponent.customForm.current?.additionalFormRef.current?.child.current?.setState({ data });
}
